var _path, _ellipse, _ellipse2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDummyChat = function SvgDummyChat(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 93,
    viewBox: "0 0 145 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.013 38.937C115.756 38.8751 116.504 38.8352 117.265 38.8352C132.307 38.8352 144.5 50.9599 144.5 65.9176C144.5 80.8753 132.307 93 117.265 93H24.6677C11.3218 93 0.5 82.2388 0.5 68.9676C0.5 55.6964 11.3218 44.9352 24.6721 44.9396C24.9926 44.9396 25.3087 44.9485 25.6248 44.9617C24.6365 42.5713 24.089 39.9552 24.089 37.2106C24.089 25.9182 33.2949 16.7638 44.6509 16.7638C48.5994 16.7638 52.2853 17.8705 55.4193 19.7917C59.9999 8.20705 71.3426 0 84.6172 0C101.938 0 115.983 13.9662 115.988 31.1948C115.988 33.8685 115.649 36.4625 115.013 38.937Z",
    fill: "#E2E6E9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.9599,
    cy: 45.5208,
    rx: 5.47063,
    ry: 7.52082,
    fill: "#9DA7B0"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 86.8317,
    cy: 45.5208,
    rx: 5.47063,
    ry: 7.52082,
    fill: "#9DA7B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9537 65.3364C65.7122 66.2878 60.4296 69.5833 57.5505 72.2791C56.3411 73.4115 54.4426 73.3491 53.3101 72.1397C52.1777 70.9303 52.2401 69.0318 53.4495 67.8993C57.0357 64.5414 63.3906 60.5724 71.0495 59.4049C78.864 58.2138 87.8804 59.9761 96.3422 67.8993C97.5516 69.0318 97.614 70.9303 96.4816 72.1397C95.3491 73.3491 93.4507 73.4115 92.2412 72.2791C85.1864 65.6733 78.0395 64.4088 71.9537 65.3364Z",
    fill: "#9DA7B0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDummyChat);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "flash-chat-assets/dummyChat.442ff8c0.svg";